import { translations } from "../data/translations";
import { getLanguage, LANGUAGE_STORAGE_KEY } from "../data/language";
import { updateProjectLinks } from "./renderProjects";

function updatePageLanguage(lang) {
  const t = translations[lang];
  document.documentElement.lang = lang;

  // Обновляем элементы с data-i18n атрибутами
  document.querySelectorAll("[data-i18n]").forEach((el) => {
    const key = el.getAttribute("data-i18n");
    const value = getNestedValue(t, key);

    if (value !== undefined) {
      // Если в значении есть HTML теги, используем innerHTML
      if (/<[a-z][\s\S]*>/i.test(value)) {
        el.innerHTML = value;
      } else {
        el.textContent = value;
      }
    }
  });

  // Обновляем кнопки с data-i18n-btn
  document.querySelectorAll("[data-i18n-btn]").forEach((el) => {
    const key = el.getAttribute("data-i18n-btn");
    const value = getNestedValue(t, key);
    if (value !== undefined) {
      el.textContent = value;
    }
  });

  // Обновляем placeholder и другие атрибуты
  document.querySelectorAll("[data-i18n-attr]").forEach((el) => {
    const key = el.getAttribute("data-i18n-attr");
    const attr = el.getAttribute("data-i18n-attr-name") || "placeholder";
    const value = getNestedValue(t, key);
    if (value !== undefined) {
      el.setAttribute(attr, value);
    }
  });

  // Обновляем текст на самой кнопке переключения языков
  const langBtn = document.querySelector("[data-lang-btn]");
  if (langBtn) {
    langBtn.textContent = lang === "ru" ? "EN" : "RU";
  }
}

function getNestedValue(obj, path) {
  return path.split(".").reduce((current, key) => current?.[key], obj);
}

export function setLanguage(lang) {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  updatePageLanguage(lang);
  updateProjectLinks();
}

export function initI18n() {
  const lang = getLanguage();

  // Обновляем статичный перевод страницы и карточки проектов
  updatePageLanguage(lang);
  updateProjectLinks();

  // Инициализируем кнопку переключения языка
  const langBtn = document.querySelector("[data-lang-btn]");
  if (langBtn) {
    langBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const currentLang = getLanguage();
      const newLang = currentLang === "ru" ? "en" : "ru";
      setLanguage(newLang);
    });
  }
}